import { render, staticRenderFns } from "./TrendyolChannelVisibility.vue?vue&type=template&id=15da9eba&scoped=true"
import script from "./TrendyolChannelVisibility.vue?vue&type=script&lang=js"
export * from "./TrendyolChannelVisibility.vue?vue&type=script&lang=js"
import style0 from "./TrendyolChannelVisibility.vue?vue&type=style&index=0&id=15da9eba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15da9eba",
  null
  
)

export default component.exports